import { ChangeDetectionStrategy, Component, computed, effect, inject, input, model, output, signal, Signal } from '@angular/core';
import { Button } from 'primeng/button';
import { Drawer } from 'primeng/drawer';
import { AbstractComponent } from '@spike/scaffolds';
import { FormGroup, FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { WalletFormComponent } from "../../forms/wallet-form/wallet-form";
import { FormFactoryService } from '../../services/utility/form-factory.service';
import { Wallet } from '../../models/wallet.model';
import { WalletStoreService } from '../../services/etiquette-service/wallet-store.service';
import { AbstractToggleSidePanelComponent } from '../abstract-toggle-side-panel/abstract-toggle-side-panel';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'spike-wallet-side-panel',
  providers:[],
  imports: [CommonModule, FormsModule, Button, Drawer, WalletFormComponent],
  templateUrl: './wallet-side-panel.html'
})
export class WalletSidePanelComponent extends AbstractToggleSidePanelComponent<Wallet>{
  private readonly formFactory = inject(FormFactoryService);
  private readonly walletStoreService = inject(WalletStoreService);

  override disabledFields: Signal<string[]> = signal([]);

  protected override buildFormArrays(data: Wallet): void {
    
  }

  public readonly form: FormGroup<any> =this.formFactory.createWalletForm();
  public readonly data = model<Wallet>();

  async onSaveClicked() {
    this.form.markAllAsTouched();
    if (this.form.valid) {
      const generalValues = this.form.getRawValue() as Wallet;
      let toSaveData: Wallet = {
        ...generalValues,
      };     
      const walletSave:Wallet = await this.walletStoreService.save(toSaveData);
      this.onSave.emit(walletSave);
      this.data.set(walletSave);
      //this.formView.set(false)
    }
  }

  async onDeleteClicked() {
    const data = this.data();
    await this.walletStoreService.deleteById(data?.finWalletId!);
    this.onDelete.emit();
  }
}